import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';

import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import { cartHasProducts, cartHasMagazines, cartHasRegularEvents, cartHasMachineTests } from './constant.js';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import $ from 'jquery';
import SimpleReactValidator from 'simple-react-validator';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

// Translation Higher Order Component
import {
    setTranslations,
    setDefaultLanguage,
    setLanguageCookie,
    setLanguage, getLanguage,
    translate,
} from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import PropTypes from 'prop-types';
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row,

} from 'reactstrap';

class Signup extends Component {
    componentDidMount() {
        // loadReCaptcha(); // Load reCAPTCHA library

        // Check if reCAPTCHA is already loaded
        // if (window.grecaptcha) {
        //     window.grecaptcha.ready(() => {
        //         console.log("reCAPTCHA is ready!");
        //     });
        // } else {
        //     console.error("reCAPTCHA failed to load. Attempting to load dynamically...m");

        //     // Dynamically add the reCAPTCHA script
        //     const script = document.createElement("script");
        //     script.src = "https://www.google.com/recaptcha/api.js?render=6LdMWkElAAAAADiLK_36r8e9ZzJPLOoz1mSWVo-J";
        //     script.async = true;
        //     script.defer = true;
        //     script.onload = () => {
        //         // console.log("reCAPTCHA script loaded successfully!");
        //         if (window.grecaptcha) {
        //             window.grecaptcha.ready(() => {
        //                 console.log("reCAPTCHA is now ready!");
        //             });
        //         }
        //     };
        //     script.onerror = () => {
        //         console.error("Failed to load reCAPTCHA script.");
        //     };

        //     document.body.appendChild(script);
        // }

    }
    constructor(props) {
        super(props);
        this.product_id = 0;
        this.state = {
            flag: 0,
            guestinfo: {
                user_id: '',
                email: '',
                password: '',
                confirm_password: '',
                sadhak_number: ''
            },
            showPassword: false,
        }
        // this.errors = {
        //     email: false,
        //     password: false
        // }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validator = new SimpleReactValidator();
        this.handleReset = this.handleReset.bind(this);
        this.signup = this.signup.bind(this);
        this.transferGuestCartToUser = this.transferGuestCartToUser.bind(this);
    }



    componentDidUpdate(prevProps) {

        // const answer_array = this.props.location.pathname.split('/');
        // const { flag } = this.state
        // alert(answer_array);
        //    if(answer_array['2'] && getLanguage()=='ma' && flag==0){
        //     this.setState({flag:1})
        //  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
        //  .then(response => response.json())
        //  .then(response =>this.setState({guestinfo: response}))  
        //  .catch(err => console.log(err))
        //    }

        //    if(answer_array['2'] && getLanguage()=='en' && (flag==1)){
        //     this.setState({flag:0})
        //  fetch(myConstClass.BASE_URL+'product/getProductInfo/'+answer_array['2']+'/'+getLanguage())
        //  .then(response => response.json())
        //  .then(response =>this.setState({guestinfo: response}))  
        //  .catch(err => console.log(err))
        //    }
    }

    handleReset() {
        this.setState({ guestinfo: { ...this.state.guestinfo, password: '', confirm_password: '' } });
    }

    // Transfer guest cart items to logged-in user's account
    async transferGuestCartToUser(user_id) {
        try {
            const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
            const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
            const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
            const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
            
            // If no guest cart items, nothing to transfer
            if (guestProducts.length === 0 && guestMagazines.length === 0 && guestEvents.length === 0 && guestMachineTests.length === 0) {
                return true;
            }

            // Check what the logged-in user already has in their database cart
            const [userHasProducts, userHasMagazines, userHasRegularEvents, userHasMachineTests] = await Promise.all([
                cartHasProducts(user_id),
                cartHasMagazines(user_id),
                cartHasRegularEvents(user_id),
                cartHasMachineTests(user_id)
            ]);

            // guestEvents contains only regular events; machine tests are in separate guestMachineTests
            const guestRegularEvents = guestEvents;
            
            // Check for conflicts between guest cart and user's existing cart
            let hasConflict = false;
            let conflictMessage = '';
            
            // If guest has products but user has magazines or events (products can coexist with machine tests)
            if (guestProducts.length > 0 && (userHasMagazines || userHasRegularEvents)) {
                hasConflict = true;
                const items = [];
                if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
                if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
                const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
                conflictMessage = getLanguage() === 'en'
                    ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding products.`
                    : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. उत्पादने जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
            }
            
            // If guest has magazines but user has products, events, or machine tests
            if (guestMagazines.length > 0 && (userHasProducts || userHasRegularEvents || userHasMachineTests)) {
                hasConflict = true;
                const items = [];
                if (userHasProducts) items.push(getLanguage() === 'en' ? 'products' : 'उत्पादने');
                if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
                if (userHasMachineTests) items.push(getLanguage() === 'en' ? 'machine tests' : 'मशीन चाचण्या');
                const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
                conflictMessage = getLanguage() === 'en'
                    ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding magazines.`
                    : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. मासिके जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
            }
            
            // If guest has regular events but user has products, magazines, or machine tests
            if (guestRegularEvents.length > 0 && (userHasProducts || userHasMagazines || userHasMachineTests)) {
                hasConflict = true;
                const items = [];
                if (userHasProducts) items.push(getLanguage() === 'en' ? 'products' : 'उत्पादने');
                if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
                if (userHasMachineTests) items.push(getLanguage() === 'en' ? 'machine tests' : 'मशीन चाचण्या');
                const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
                conflictMessage = getLanguage() === 'en'
                    ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding events.`
                    : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. कार्यक्रम जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
            }
            
            // If guest has machine tests but user has magazines or regular events (machine tests can coexist with products)
            if (guestMachineTests.length > 0 && (userHasMagazines || userHasRegularEvents)) {
                hasConflict = true;
                const items = [];
                if (userHasMagazines) items.push(getLanguage() === 'en' ? 'magazines' : 'मासिके');
                if (userHasRegularEvents) items.push(getLanguage() === 'en' ? 'events' : 'कार्यक्रम');
                const itemsText = items.join(getLanguage() === 'en' ? ' and ' : ' आणि ');
                conflictMessage = getLanguage() === 'en'
                    ? `Your account already has ${itemsText} in cart. Please checkout or clear your cart before adding machine tests.`
                    : `तुमच्या खात्यात आधीच ${itemsText} कार्टमध्ये आहेत. मशीन चाचण्या जोडण्यापूर्वी कृपया चेकआउट करा किंवा कार्ट साफ करा.`;
            }

            // If conflict exists, save warning to show on cart page and DON'T transfer
            if (hasConflict) {
                // Save conflict message to localStorage to show on cart page after redirect
                localStorage.setItem('cart_conflict_message', conflictMessage);
                // Keep guest cart in localStorage - don't clear it
                return false;
            }

            // No conflict - proceed with transfer
            
            // Transfer products
            if (guestProducts.length > 0) {
                for (const product of guestProducts) {
                    try {
                        await fetch(
                            myConstClass.BASE_URL + `cart/addProductToCart/${product.product_id}/${product.quantity}/${user_id}`,
                            { method: 'GET' }
                        );
                    } catch (err) {
                        console.error(`Failed to transfer product ${product.product_id}:`, err);
                    }
                }
            }
            
            // Transfer magazines
            if (guestMagazines.length > 0) {
                for (const magazine of guestMagazines) {
                    try {
                        await fetch(
                            myConstClass.BASE_URL + `cart/addMagazineToCart/${magazine.package_id}/${user_id}`,
                            { method: 'GET' }
                        );
                    } catch (err) {
                        console.error(`Failed to transfer magazine ${magazine.package_id}:`, err);
                    }
                }
            }
            
            // Transfer regular events
            if (guestEvents.length > 0) {
                for (const event of guestEvents) {
                    try {
                        await fetch(
                            myConstClass.BASE_URL + `cart/addEventToCart/${event.schedule_id}/${user_id}/${event.parent}/${event.child || 0}`,
                            { method: 'GET' }
                        );
                    } catch (err) {
                        console.error(`Failed to transfer event ${event.event_id || event.schedule_id}:`, err);
                    }
                }
            }
            
            // Transfer machine tests
            if (guestMachineTests.length > 0) {
                for (const machineTest of guestMachineTests) {
                    try {
                        await fetch(
                            myConstClass.BASE_URL + `cart/addMachineTestEventToCart/${machineTest.event_id}/${user_id}/${machineTest.parent || 1}/${machineTest.child || 0}`,
                            { method: 'GET' }
                        );
                    } catch (err) {
                        console.error(`Failed to transfer machine test ${machineTest.event_id}:`, err);
                    }
                }
            }
            
            // Clear guest cart from localStorage after successful transfer
            localStorage.removeItem('guest_cart_products');
            localStorage.removeItem('guest_cart_magazines');
            localStorage.removeItem('guest_cart_events');
            localStorage.removeItem('guest_mt_cart');
            
            return true;
        } catch (error) {
            console.error('Error transferring guest cart:', error);
            return false;
        }
    }

    async signup(res, type) {
        let postData;
        if (type === "facebook" && res.id) {
            postData = {
                name: res.name,
                provider: type,
                email: res.email,
                provider_id: res.id,
                token: res.accessToken,
            };
        }
        if (type === "google" && res.profileObj.googleId) {
            postData = {
                name: res.profileObj.name,
                provider: type,
                email: res.profileObj.email,
                provider_id: res.profileObj.googleId,
            };
        }

        if (postData) {
            console.log("PostData : ", postData);
            fetch(myConstClass.BASE_URL + `users/socialLoginUser/`, {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((response) => response.json())
                .then(async (response) => {
                    this.setState({ eventinfo: response });
                    var status = this.state.eventinfo.status;
                    var message = this.state.eventinfo.message;
                    if (status == "true") {
                        var user_id = this.state.eventinfo.user_details.user_id;
                        var first_name = this.state.eventinfo.user_details.first_name;
                        var middle_name = this.state.eventinfo.user_details.middle_name;
                        var last_name = this.state.eventinfo.user_details.last_name;
                        var email = this.state.eventinfo.user_details.email;
                        var profile_picture = this.state.eventinfo.user_details.profile_picture;
                        var is_verify_sadhak_no = this.state.eventinfo.user_details.is_verify_sadhak_no;
                        localStorage.setItem("user_id", user_id);
                        localStorage.setItem("first_name", first_name);
                        localStorage.setItem("middle_name", middle_name);
                        localStorage.setItem("last_name", last_name);
                        localStorage.setItem("email", email);
                        localStorage.setItem("success", message);
                        localStorage.setItem("profile_picture", profile_picture);
                        localStorage.setItem("is_verify_sadhak_no", is_verify_sadhak_no);
                        toast("" + message, { containerId: "B", type: toast.TYPE.SUCCESS });
                        
                        // Transfer guest cart items to user's account
                        await this.transferGuestCartToUser(user_id);
                        
                        setTimeout(this.props.history.push('/'), 1000);
                    } else {
                        if (this.state.eventinfo.mstatus == "true") {
                            $("#fbModel").modal("show");
                            $("#postData").val(JSON.stringify(postData));
                        } else {
                            toast(message, { containerId: "B", type: toast.TYPE.ERROR });
                        }
                    }
                });
        }
    }

    async handleSubmit(e) {
        //Code for recaptcha added on 29.03.23 SGH
        e.preventDefault();

        // Execute reCAPTCHA v3 Enterprise
        // if (!window.grecaptcha || !window.grecaptcha.enterprise) {
        //     console.error('reCAPTCHA not loaded:', {
        //         grecaptcha: !!window.grecaptcha,
        //         enterprise: window.grecaptcha ? !!window.grecaptcha.enterprise : false
        //     });
        //     toast('reCAPTCHA is not loaded yet. Please refresh the page.', { 
        //         containerId: 'B', 
        //         type: toast.TYPE.ERROR 
        //     });
        //     return;
        // }

        $('#btn_click').css('display', 'none');
        $('#loader').css('display', 'inline');

        try {
            // // Get reCAPTCHA token
            // await window.grecaptcha.enterprise.ready(async () => {
            //     console.log('reCAPTCHA ready, executing for SIGNUP...');
            //     const token = await window.grecaptcha.enterprise.execute('6LervOgrAAAAAJN4JTdfI_4MJmiDKRRVap4qBzT7', {action: 'SIGNUP'});
                
            //     console.log('reCAPTCHA token received:', token ? 'YES (length: ' + token.length + ')' : 'NO');
                
            //     if (!token) {
            //         console.error('No reCAPTCHA token received');
            //         toast('reCAPTCHA verification failed. Please try again.', { 
            //             containerId: 'B', 
            //             type: toast.TYPE.ERROR 
            //         });
            //         $('#btn_click').css('display', 'inline');
            //         $('#loader').css('display', 'none');
            //         return;
            //     }

        // if (!window.grecaptcha || !window.grecaptcha.execute) {
        //     console.error("reCAPTCHA is not loaded yet.");
        //     alert("reCAPTCHA is not ready. Please wait and try again.");
        //     return;
        // }
        
        // const token = await window.grecaptcha.execute('6LdMWkElAAAAADiLK_36r8e9ZzJPLOoz1mSWVo-J', { action: 'submit' });

        // console.log("ReCAPTCHA Token:", token);
        // if (!token) {
        //     alert('Please verify that you are not a robot.');
        //     return;
        // }


        // if (!token) {
        //     alert('Please verify that you are not a robot.');
        //     return;
        // }
        //Rest of the Code follows 29.03.23 SGH

        const { email, password, confirm_password } = this.state.guestinfo;

        // Validate each field
        const isEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
        const isPasswordValid = password && password.length >= 8;
        const isPasswordMatch = password === confirm_password;

        if (
            this.validator.allValid() &&
            isEmailValid &&
            isPasswordValid &&
            isPasswordMatch
        ) {
            // console.log('this.refs', $('#pform').serializeArray());
            const { email, password, confirm_password, sadhak_number } = this.state.guestinfo;
            
            const userData = {
                email,
                password,
                confirm_password,
                sadhak_number, // optional
                // recaptcha_token: token  // Send token to backend
            };
            
            console.log('Sending registration request with:', {
                email: userData.email,
                hasPassword: !!userData.password,
                hasConfirmPassword: !!userData.confirm_password,
                hasSadhakNumber: !!userData.sadhak_number,
                // hasToken: !!userData.recaptcha_token,
                // tokenLength: userData.recaptcha_token ? userData.recaptcha_token.length : 0
            });

            fetch(myConstClass.AUTH_API + '/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            }).then(response => response.json())

            .then(response => {
                console.log('Registration response:', response);
                this.setState({ eventinfo: response })
                var status = this.state.eventinfo.status;
                var message = this.state.eventinfo.message;
                var otp_email = this.state.eventinfo.email;
                
                console.log('Email from API response:', otp_email);
                
                if (status === 'true') {
                    // If API doesn't return email, use the email from form
                    const emailToStore = otp_email || email;
                    localStorage.removeItem('otp_email');
                    localStorage.setItem('otp_email', emailToStore);
                    console.log('Stored email in localStorage:', emailToStore);
                    //var user_id =  this.state.eventinfo.user_details.user_id;
                    //localStorage.setItem('user_id', user_id);
                    localStorage.setItem('success', message);
                    toast('' + message, { containerId: 'B', type: toast.TYPE.SUCCESS });
                    setTimeout(this.props.history.push('verifyotp'), 10);
                    //toast(message, {containerId: 'B',type: toast.TYPE.SUCCESS}),setTimeout(this.props.history.push('signin'),100);
                } else {
                    toast(message, { containerId: 'B', type: toast.TYPE.ERROR });
                    $('#btn_click').css('display', 'inline');
                    $('#loader').css('display', 'none');
                    //toast("Wow so easy !");
                }
            })
            //}).then(toast('User Added Successfully..!', {containerId: 'B',type: toast.TYPE.SUCCESS}),setTimeout(this.props.history.push('signup'),100))
            .catch((error) => console.log('error: ', error));
    } else {
    $('#btn_click').css('display', 'inline');
    $('#loader').css('display', 'none');
    //alert('here');
    this.validator.showMessages();
    // console.log('validations' + this.validator.showMessages());
    // toast('Please fill all required fields.', {containerId: 'B',type: toast.TYPE.ERROR})
    if (!email && !password && !confirm_password) {
        toast.error("All required fields are required.");
    }
    else if (!isEmailValid || !email) {
        toast.error("Invalid email format. Please enter a valid email.");
    }
    else if (!isPasswordValid || !password) {
        toast.error("Password must be at least 8 characters long.");
    }
    else if (!isPasswordMatch) {
        toast.error("Passwords do not match.");
    }
}
             // End grecaptcha.enterprise.ready
        } catch (error) {
            // console.error('reCAPTCHA error:', error);
            // $('#btn_click').css('display', 'inline');
            // $('#loader').css('display', 'none');
            // toast('reCAPTCHA verification failed. Please try again.', { 
            //     containerId: 'B', 
            //     type: toast.TYPE.ERROR 
            // });
        }
    }

render() {
    const { guestinfo } = this.state;
    const { t } = this.props;

    const responseGoogle = (response) => {
        console.log("google console");
        console.log(response);
        this.signup(response, "google");
    };

    return (
        <div className="App">
            <ToastContainer />
            <NewHeader />
            
            <div className="container">
                {/* Breadcrumb */}
                {/* <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-white mb-4">
                        <li className="breadcrumb-item"><Link to="/">{t('home.home')}</Link></li>
                        <li className="breadcrumb-item active">{t('home.Registration')}</li>
                    </ol>
                </nav> */}

                {/* Main Content */}
                <div className="row mt-5 p-auto">
                    <div className="col-12">
                        <h2 className="mb-2 ">Registration</h2>
                        {/* <p>Please fill in the details below: <span className="text-danger">* Mandatory</span></p> */}
                    </div>
                </div>

                <div className="row mt-4">
                    {/* Left Side - Form - Full width on mobile */}
                    <div className="col-12 col-md-5">
                        <Form id="pform" onSubmit={this.handleSubmit}>
                            <div className="form-group mb-3">
                                <label>Email ID<span className="text-danger">*</span></label>
                                <input 
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email Id"
                                    value={guestinfo.email}
                                    onChange={e => this.setState({ guestinfo: { ...guestinfo, email: e.target.value } })}
                                    onBlur={() => this.validator.showMessageFor('email')}
                                />
                                {this.validator.message('email', guestinfo.email, 'required|email')}
                            </div>

                            <div className="form-group mb-3">
                                <label>Create Password<span className="text-danger">*</span></label>
                                <div className='position-relative'>
                                    <input 
                                        type={this.state.showPassword ? "text" : "password"}
                                        className="form-control"
                                        placeholder="Enter Password"
                                        value={guestinfo.password}
                                        onChange={e => this.setState({ guestinfo: { ...guestinfo, password: e.target.value.replace(" ", "") } })}
                                        onCopy={e => e.preventDefault()}
                                        onPaste={e => e.preventDefault()}
                                    />
                                    <button
                                        type="button"
                                        class="btn btn-link position-absolute"
                                        style={{
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            padding: "0",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#9d0b0e",
                                        }}
                                        onClick={() =>
                                            this.setState({
                                            showPassword: !this.state.showPassword,
                                            })
                                        }
                                        tabIndex="-1"
                                        >
                                        {this.state.showPassword ? (
                                            <i class="fas fa-eye-slash"></i>
                                        ) : (
                                            <i class="fas fa-eye"></i>
                                        )}
                                        </button>
                                </div>
                                
                                {this.validator.message('password', guestinfo.password, 'required|min:8')}
                            </div>

                            <div className="form-group mb-3">
                                <label>Confirm Password<span className="text-danger">*</span></label>
                                <div className="position-relative">
                                        <input 
                                            type={this.state.showPassword ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Re-Enter Password"
                                            value={guestinfo.confirm_password}
                                            onChange={e => this.setState({ guestinfo: { ...guestinfo, confirm_password: e.target.value.replace(" ", "") } })}
                                            onCopy={e => e.preventDefault()}
                                            onPaste={e => e.preventDefault()}
                                        />
                                        <button
                                            type="button"
                                            class="btn btn-link position-absolute"
                                            style={{
                                                right: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                padding: "0",
                                                border: "none",
                                                cursor: "pointer",
                                                color: "#9d0b0e",
                                            }}
                                            onClick={() =>
                                                this.setState({
                                                showPassword: !this.state.showPassword,
                                                })
                                            }
                                            tabIndex="-1"
                                            >
                                            {this.state.showPassword ? (
                                                <i class="fas fa-eye-slash"></i>
                                            ) : (
                                                <i class="fas fa-eye"></i>
                                            )}
                                        </button>
                                </div>
                                
                                {this.validator.message('confirm_password', guestinfo.confirm_password, 'required|min:8')}
                            </div>

                            {/* <div className="form-group mb-4">
                                <label>Sadhak No. <span className="text-danger">(For Manashakti Sadhaks only)</span></label>
                                <input 
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Sadhak Number"
                                    value={guestinfo.sadhak_number}
                                    onChange={e => this.setState({ guestinfo: { ...guestinfo, sadhak_number: e.target.value } })}
                                />
                            </div> */}

                            <div className="row">
                                <div className="col-12 col-md-6 mb-2 mb-md-0">
                                    <button 
                                        type="submit" 
                                        className="btn w-100"
                                        style={{
                                            backgroundColor: '#9d0b0e',
                                            color: 'white',
                                            border: '1px solid #9d0b0e'
                                        }}
                                    >
                                        REGISTER
                                    </button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button 
                                        type="reset" 
                                        onClick={this.handleReset} 
                                        className="btn w-100"
                                        style={{
                                            backgroundColor: 'transparent',
                                            color: '#9d0b0e',
                                            border: '1px solid #9d0b0e'
                                        }}
                                    >
                                        RESET
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </div>

                    {/* Center - OR - Full width centered on mobile */}
                    <div className="col-12 col-md-2 d-flex align-items-center justify-content-center my-3 my-md-0">
                        <h3 className="mb-0">OR</h3>
                    </div>

                    {/* Right Side - Google Sign In - Full width on mobile */}
                    <div className="col-12 col-md-5 d-flex align-items-center justify-content-start">
                        <div className="w-100" style={{ maxWidth: '350px' }}>
                            {/* <h4 className="mb-4">Click Below to Sign Up through Gmail/Google</h4> */}
                            <GoogleLogin
                                clientId="800455904093-eonvlc21ffngqlg3b2u7kguff1gtbpa1.apps.googleusercontent.com"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                render={renderProps => (
                                    <button 
                                        onClick={renderProps.onClick} 
                                        className="w-100"
                                        style={{
                                            cursor: 'pointer',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            padding: '12px 24px',
                                            backgroundColor: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            color: "#3c4043",
                                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                                            transition: "box-shadow 0.3s ease"
                                            }}
                                            onMouseEnter={(e) => {
                                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.2)";
                                            }}
                                            onMouseLeave={(e) => {
                                            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.15)";
                                        }}
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24">
                                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                                        </svg>
                                        Login with Google
                                    </button>
                                )}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}   
}


// Listen for when the user is leaving the page
// window.addEventListener('beforeunload', function (e) {
//     // Hide the captcha element
//     if (typeof window.grecaptcha !== 'undefined') y{
//         window.grecaptcha.reset();
//     }
// });

Signup.propTypes = {
    t: PropTypes.func.isRequired,
};
export default translate(Signup);
